import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {EvaluatedTable} from 'notebook/tables/excess/EvaluationConstants';
import {ProcessOutputStructuredTable} from 'processes/tables/ProcessOutputStructuredTableAdapter';
import {ProcessTaskStructuredTable} from 'processes/tables/ProcessTaskStructuredTableAdapter';

import {FixFailedRoutingAndMappingModalQuery} from './__generated/FixFailedRoutingAndMappingModalQuery';

export type ProcessTask = ExtractByTypename<
  FixFailedRoutingAndMappingModalQuery['processTask'],
  'ProcessTaskNode'
>;

export type ProcessOutput = ProcessTask['outputs'][number];

export type ProcessAsyncRecord = ProcessTask['processAsyncRecords'][number];

export type SchemaMapper = ExtractByTypename<
  ProcessAsyncRecord['asyncData'],
  'ProcessFlowchartExecuteSchemaMapperRecordNode'
>['schemaMapper'];

type ProcessAsyncRecordData = ProcessAsyncRecord['asyncData'];

type StartAutomatedMappingRecord = ExtractByTypename<
  ProcessAsyncRecordData,
  'ProcessStartAutomatedMappingRecordNode'
>;

type ExecuteSchemaMapperRecord = ExtractByTypename<
  ProcessAsyncRecordData,
  'ProcessFlowchartExecuteSchemaMapperRecordNode'
>;

type LegacySchemaMappingRecord = ExtractByTypename<
  ProcessAsyncRecordData,
  'ProcessFlowchartSchemaMappingRecordNode'
>;

export function isAsyncDataExecuteSchemaMapper(
  asyncData: ProcessAsyncRecordData
): asyncData is ExecuteSchemaMapperRecord | LegacySchemaMappingRecord {
  return (asyncData as unknown as ExecuteSchemaMapperRecord | LegacySchemaMappingRecord).schemaMapper != null;
}

export function isAsyncDataStartAutomatedMapping(
  asyncData: ProcessAsyncRecordData
): asyncData is StartAutomatedMappingRecord {
  return !isAsyncDataExecuteSchemaMapper(asyncData);
}

export interface MapperErrorRecord extends ProcessAsyncRecord {
  asyncData: ExecuteSchemaMapperRecord | LegacySchemaMappingRecord;
}

export interface RoutingErrorRecord extends ProcessAsyncRecord {
  asyncData: StartAutomatedMappingRecord;
}

export function isAsyncRecordRoutingRecord(
  asyncRecord: ProcessAsyncRecord
): asyncRecord is RoutingErrorRecord {
  return isAsyncDataStartAutomatedMapping(asyncRecord.asyncData);
}

export interface MappingTableData {
  structuredTable: ProcessTaskStructuredTable | ProcessOutputStructuredTable;
  computedTable: EvaluatedTable;
  mapper: SchemaMapper;
}

export interface FromItemIdsToTables {
  [id: string]: Array<MappingTableData>;
}

export enum FixFailedRoutingAndMappingStepKey {
  SELECT_ERRORS = 'SELECT_ERRORS',
  SELECT_DOWNSTREAM_NODES = 'SELECT_DOWNSTREAM_NODES',
  TABLE_REVIEW = 'TABLE_REVIEW',
}
